module.exports = __webpack_public_path__ + "img/upload.8e9cd904.png";